import React from "react"
import tw, { css, styled } from "twin.macro"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import { SlideProps } from "."

import Container from "../components/container"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import NextPageContainer from "../components/nextPageContainer"
import IconSubsidies from "../icons/subsidies"
import IconSubsidiesWhite from "../icons/subsidiesWhite"

const Header = styled.h2`
  ${tw`md:block text-center font-sans text-2xl mb-6`}
`

const Description = styled.p`
  ${tw`text-center font-sans text-sm mb-6`}
`

const SubsidiesSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {

  const data = useStaticQuery(query);

  const imageSource = [
    {
      ...data.imageBackground.childImageSharp.fixed,
      media: `(min-width: 768px)`,
    },
  ]

  return (
    <SlideSection fullHeight>
      <div css={[tw`flex flex-col items-center justify-center w-full h-full`]}>
        <div className="left-right-content-wrapper" css={[tw`flex flex-row h-full items-end lg:(relative items-center)`]}>
          <div css={[
            tw`absolute inset-0 flex flex-row justify-center items-start lg:(inset-y-0 right-0 left-auto)`,
            tw`transition duration-500 ease-out delay-100`,
            !slideVisible && tw`opacity-0 transform translate-x-16`
          ]}>
            <Img
              style={{ height: '100%' }}
              fixed={imageSource}
              imgStyle={{ objectFit: 'contain', objectPosition: 'top' }}
            />
          </div>
          <div css={[
            tw`absolute hidden md:block`,
            css`bottom:9rem; right: 5rem`,
            // transitions
            tw`transition duration-500 ease-out delay-100`,
            !slideVisible && tw`opacity-0 transform -translate-y-16`]}>
            <IconSubsidiesWhite />
          </div>

          {/* relative to make the ordering correct */}
          <div className="text-wrapper" css={[tw`relative`]}>
            <Header css={[tw`font-text font-bold leading-8 text-standard-title text-center text-3xl md:text-5xl`, css`line-height: 1.2em;`]}>
              Subsidies <br /> available now*
            </Header>
            <p css={[tw`font-text leading-7 md:leading-8 text-sm tracking-normal text-center`]}>
              Apprenticeship Boost is a payment to employers to support your Apprentice(s) until August 2022. Receive $1,000 per month for each Apprentice in their first year, and $500 per month in their second year. Plus, until 31 December 2022, the training fees for Automotive Apprenticeships are completely free!
            </p>
            <p css={[tw`font-text leading-7 lg:mt-16 md:leading-8 text-sm tracking-normal text-center`]}>
              *Visit <a href="https://mito.nz">mito.nz</a> for eligibility details
            </p>
          </div>
        </div>
        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

export const query = graphql`
  query {
    imageBackground: file(relativePath: { eq: "Subsidies.png" }) {
      childImageSharp {
        fluid(maxWidth: 2000, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
      childImageSharp {
        fixed(width: 764, quality: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }

  }
`

export default SubsidiesSlide
